/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  document.addEventListener('click', function(event) {
    const closeButton = event.target.closest('[data-discount-close]');
    if (!closeButton) return;

    const wrapper = closeButton.closest('.cart__promo-wrapper');
    if (!wrapper) return;

    const trigger = wrapper.querySelector('[data-collapsible-trigger]');
    if (trigger && trigger.classList.contains('is-expanded')) {
      trigger.click();
    }
  });

  document.addEventListener('click', function(event) {
    const playButton = event.target.closest('[data-promo-video-play]');
    if (!playButton) return;

    event.preventDefault();

    const wrapper = playButton.closest('[data-promo-video]');
    if (!wrapper) return;

    const video = wrapper.querySelector('[data-promo-video-el]');
    if (!video) return;

    wrapper.classList.add('is-playing');

    const played = video.play();
    if (played && typeof played.catch === 'function') {
      played.catch(function() {
        video.muted = true;
        video.play();
      });
    }
  });

  function initClickMegaMenu() {
    const header = document.querySelector('[data-site-header][data-nav-open-on-click]');
    if (!header) return;

    const disclosures = header.querySelectorAll('hover-disclosure');
    if (!disclosures.length) return;

    disclosures.forEach(function(el) {
      const proto = Object.getPrototypeOf(el);
      if (!proto || typeof proto.showDisclosure !== 'function') return;

      const show = proto.showDisclosure.bind(el);
      const hide = proto.hideDisclosure.bind(el);

      el.showDisclosure = function() {};
      el.hideDisclosure = function() {};
      el.clickShow = show;
      el.clickHide = hide;

      const topLink = el.querySelector('[data-top-link]');
      if (!topLink) return;

      topLink.addEventListener('click', function(event) {
        event.preventDefault();
        const isOpen = el.classList.contains('is-visible');

        disclosures.forEach(function(other) {
          if (other !== el && typeof other.clickHide === 'function') other.clickHide();
        });

        if (isOpen) {
          el.clickHide();
        } else {
          el.clickShow();
        }
      });
    });

    document.addEventListener('click', function(event) {
      if (event.target.closest('hover-disclosure')) return;
      disclosures.forEach(function(el) {
        if (typeof el.clickHide === 'function') el.clickHide();
      });
    });

    document.addEventListener('keyup', function(event) {
      if (event.code !== 'Escape') return;
      disclosures.forEach(function(el) {
        if (typeof el.clickHide === 'function') el.clickHide();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initClickMegaMenu);
  } else {
    initClickMegaMenu();
  }

  function syncFooterAccordions() {
    const compact = window.innerWidth < 1024;
    const triggers = document.querySelectorAll('.footer-block--menu [data-collapsible-trigger]');

    triggers.forEach(function(trigger) {
      if (compact) {
        trigger.removeAttribute('data-collapsible-trigger-mobile');
        return;
      }

      trigger.setAttribute('data-collapsible-trigger-mobile', '');

      const dropdown = document.getElementById(trigger.getAttribute('aria-controls'));
      if (dropdown) {
        dropdown.style.removeProperty('height');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncFooterAccordions);
  } else {
    syncFooterAccordions();
  }

  window.addEventListener('resize', syncFooterAccordions);
  document.addEventListener('shopify:section:load', syncFooterAccordions);


  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
